<div class="dismissButton" [id]="buttonId">
  <button
    class="dismissButton__left"
    [class.dismissButton__full]="ppReminders.length < 2"
    (click)="dismissReminder(false)"
    data-test="dismissRemindersButton"
    >
    <span class="dismissButton__text">
      {{ 'dismiss' | ppTranslate }}
    </span>
  </button>

  @if (ppReminders.length > 1) {
    <section
      class="dismissButton__right"
      (click)="toogleDismissDropdown()"
      data-test="dismissSelectListButton"
      >
      <pp-icon
        ppClass="setSize18"
        ppColor="white"
      [ppSrc]="
        dropdown.visible && dropdown.buttonId === buttonId
          ? EIconPath.ICON_MISC_UP_ARROW_18
          : EIconPath.ICON_MISC_DOWN_ARROW_18
      "
      ></pp-icon>
    </section>
  }
</div>
